// extracted by mini-css-extract-plugin
export var fadeIn = "_jd-1";
export var modalContent = "_jd-3";
export var overlay = "_jd-0";
export var popoverContent = "_jd-2";
export var results = "_jd-5";
export var searchInputWrapper = "_jd-4";